export default "__VITE_ASSET__901abebb__"